<template>
  <div id="app">
    <Alert />
    <Header />
    <router-view />
  </div>
</template>

<script>
import Header from 'components/Header'
import Alert from 'components/Global/Alert'
import * as chat from '@/utils/chat'
import { saveAs } from 'file-saver'
export default {
  name: 'infoDiagram',
  components: {
    Header, Alert
  },
  provide () {
    return {
      sendFile: this.sendFile
    }
  },
  methods: {
    initChat () {
      const store = this.$store
      const user = this.$store.user
      window.addEventListener('chatwoot:ready', function () {
        if (user) {
          chat.addUserData(user)
        } else {
          store.subscribe((mutation, state) => {
            if (mutation.type === 'getUser') {
              chat.addUserData(state.user)
            }
          })
        }
      })
      return new Promise((resolve) => {
        const script = document.createElement('script')
        script.onload = () => {
          resolve()
          window.chatwootSDK.run({
            websiteToken: 'F3Rji2qD1us4sT9YserRYBoz',
            baseUrl: 'https://chat.infodiagram.com'
          })
        }
        script.async = true
        script.defer = true
        script.src = 'https://chat.infodiagram.com/packs/js/sdk.js'
        document.head.appendChild(script)
      })
    },
    sendFile (response) {
      const fileName = response.headers['content-disposition'].split('filename=')[1].replace(/['"]/g, '')
      const type = response.headers['content-type']
      const blob = new Blob([response.data], { type, responseType: 'arraybuffer' })
      saveAs(blob, fileName)
    }
  },
  async created () {
    await this.initChat()
  }
}
</script>

<style lang="scss">
  @import './assets/scss/var';
  @import '../node_modules/bootstrap/scss/bootstrap';
  @import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
  @import '../node_modules/lightgallery.js/src/css/lightgallery.css';
  @import '../node_modules/lightgallery.js/src/css/lg-transitions.css';
  @import '../node_modules/vue-tour/dist/vue-tour.css';
  @import './assets/scss/fonts';
  @import './assets/scss/base';
  @import './assets/scss/pages';
  @import './assets/scss/tour';
</style>
